/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Funnel_DescInputs */

const en_analytics_funnel_desc = /** @type {(inputs: Analytics_Funnel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How your applications progress through each stage.`)
};

const de_analytics_funnel_desc = /** @type {(inputs: Analytics_Funnel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie deine Bewerbungen die einzelnen Phasen durchlaufen.`)
};

const fr_analytics_funnel_desc = /** @type {(inputs: Analytics_Funnel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment tes candidatures progressent à travers chaque étape.`)
};

const es_analytics_funnel_desc = /** @type {(inputs: Analytics_Funnel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo progresan sus solicitudes a través de cada etapa.`)
};

const it_analytics_funnel_desc = /** @type {(inputs: Analytics_Funnel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come le tue candidature progrediscono attraverso ogni fase.`)
};

const nl_analytics_funnel_desc = /** @type {(inputs: Analytics_Funnel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe je sollicitaties door elke fase vorderen.`)
};

const pl_analytics_funnel_desc = /** @type {(inputs: Analytics_Funnel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak Twoje aplikacje przechodzą przez kolejne etapy.`)
};

const fi_analytics_funnel_desc = /** @type {(inputs: Analytics_Funnel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miten hakemuksesi etenevät vaiheesta toiseen.`)
};

const da_analytics_funnel_desc = /** @type {(inputs: Analytics_Funnel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvordan dine ansøgninger bevæger sig gennem hvert stadie.`)
};

const sv_analytics_funnel_desc = /** @type {(inputs: Analytics_Funnel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hur dina ansökningar fortskrider genom varje steg.`)
};

/**
* | output |
* | --- |
* | "How your applications progress through each stage." |
*
* @param {Analytics_Funnel_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_funnel_desc = /** @type {((inputs?: Analytics_Funnel_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Funnel_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_funnel_desc(inputs)
	if (locale === "fr") return fr_analytics_funnel_desc(inputs)
	if (locale === "es") return es_analytics_funnel_desc(inputs)
	if (locale === "it") return it_analytics_funnel_desc(inputs)
	if (locale === "nl") return nl_analytics_funnel_desc(inputs)
	if (locale === "pl") return pl_analytics_funnel_desc(inputs)
	if (locale === "fi") return fi_analytics_funnel_desc(inputs)
	if (locale === "da") return da_analytics_funnel_desc(inputs)
	if (locale === "sv") return sv_analytics_funnel_desc(inputs)
	return en_analytics_funnel_desc(inputs)
});